import { render, staticRenderFns } from "./SelectMenuItem.vue?vue&type=template&id=0b3d74b7&"
import script from "./SelectMenuItem.vue?vue&type=script&lang=js&"
export * from "./SelectMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports